// frontend/src/components/pages/MemoInputPage.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export default function MemoInputPage() {
  const [allMemos, setAllMemos] = useState([]);
  const [editing, setEditing] = useState(null); // memo 객체 or null
  const [content, setContent] = useState('');

  /* ---------- API ---------- */
  const fetchAll = () =>
    axios
      .get(`${process.env.REACT_APP_API_URL}/memos/`)
      .then((res) => setAllMemos(res.data))
      .catch(console.error);

  useEffect(() => {
    fetchAll();
  }, []);

  /* ---------- 핸들러 ---------- */
  const handleSave = async () => {
    if (!content.trim()) return;
    if (editing) {
      await axios.put(`${process.env.REACT_APP_API_URL}/memos/${editing.id}`, {
        content,
      });
    } else {
      await axios.post(`${process.env.REACT_APP_API_URL}/memos/`, {
        target_date: new Date().toISOString().slice(0, 10),
        content,
      });
    }
    setContent('');
    setEditing(null);
    fetchAll();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('정말 삭제할까요?')) return;
    await axios.delete(`${process.env.REACT_APP_API_URL}/memos/${id}`);
    fetchAll();
    if (editing?.id === id) {
      setEditing(null);
      setContent('');
    }
  };

  // 공통 스타일 클래스
  const headClass =
    'px-3 py-2 border border-neutral-300 bg-neutral-100 whitespace-nowrap text-center text-lg font-medium';
  const cellClass =
    'px-3 py-2 border border-neutral-300 bg-white whitespace-nowrap text-center text-lg';

  /* ---------- UI ---------- */
  return (
    <div className="max-w-[1200px] mx-auto my-8">
      <h2 className="mb-3 text-xl font-semibold text-neutral-900">
        알림 메모 관리
      </h2>

      {/* 입력/편집 영역 */}
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={6}
        placeholder="알림 메모 입력"
        className="w-full resize-y rounded-md border border-neutral-300 p-3 text-neutral-900
                   focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
      />
      <div className="text-right mt-1.5">
        {editing && (
          <button
            onClick={() => setEditing(null)}
            className="inline-flex items-center justify-center rounded-md
                       border border-neutral-300 bg-white px-3 py-2 text-lg font-medium text-neutral-800
                       hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-sky-500 mr-4"
          >
            새 알림 메모
          </button>
        )}
        <button
          onClick={handleSave}
          className="inline-flex items-center justify-center rounded-md
                     bg-sky-600 px-3 py-2 text-lg font-medium text-white
                     hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
        >
          {editing ? '수정' : '등록'}
        </button>
      </div>

      {/* 전체 메모 리스트 */}
      <h3 className="mt-8 mb-2 text-lg font-semibold text-neutral-900">
        알림 메모 리스트
      </h3>
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-neutral-100">
            <th className={headClass}>날짜</th>
            <th className={headClass}>내용</th>
            <th className={headClass}>수정</th>
            <th className={headClass}>삭제</th>
          </tr>
        </thead>
        <tbody>
          {allMemos.map((memo) => (
            <tr key={memo.id}>
              <td className={cellClass}>{memo.target_date}</td>

              {/* 내용 셀: 줄바꿈 허용 + 최소 폭 유지 */}
              <td className="border border-neutral-300 px-2 py-1.5 text-left whitespace-pre-wrap min-w-[800px]">
                {memo.content}
              </td>

              <td className={cellClass}>
                <button
                  onClick={() => {
                    setEditing(memo);
                    setContent(memo.content);
                  }}
                  className="text-2xl hover:opacity-80"
                  title="수정"
                >
                  ✏️
                </button>
              </td>
              <td className={cellClass}>
                <button
                  onClick={() => handleDelete(memo.id)}
                  className="text-2xl hover:opacity-80"
                  title="삭제"
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
